import React, { useState, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { UserContext } from '../../context/User';
import { useHistory } from "react-router-dom";
import Loading from '../Loading';
import { somethingWentWrongNotice } from '../UI/Notifications';
import AlertMessage from '../AlertMessage';
import Select from '../UI/Select';
import classes from './index.module.scss';
import DateRange from 'components/UI/DateRange';
import { matchingReportsGet } from '../../api';
import date from 'date-and-time';

const INITIAL_DATE = date.format(new Date, 'YYYY-MM-DD')

const MatchingReports = () => {
  const [loading, setLoading] = useState(false);
  const { setUser, setIsLoggedIn } = useContext(UserContext);
  const history = useHistory();

  const [count, setCount] = useState(0);
  const [fromDate, setFromDate] = useState(INITIAL_DATE);
  const [toDate, setToDate] = useState(INITIAL_DATE);
  const [entity, setEntity] = useState({value: "opportunities", label: "Opportunities"});
  const [showMessage, setShowMessage] = useState(false);

  const MATCHING_REPORTS_ALERT = `
    <div>
      <p class="mb-0">
        The total matches for ${entity.label} between ${fromDate} and ${toDate} is ${count}.
      </p>
    </div>
    `;

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push('/');
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout()
    } else {
      somethingWentWrongNotice("Matching Reports");
    }

    setLoading(false);
  }

  const chooseEntityHandler = selectedOption => {
    setShowMessage(false);
    setEntity({value: selectedOption.value, label: selectedOption.label});
  }

  const handleTimeCallback = (start, end) => {
    setShowMessage(false);
    setFromDate(date.format(start._d, 'YYYY-MM-DD'));
    setToDate(date.format(end._d, 'YYYY-MM-DD'));
  }   

  const params = {
    entity: entity.value,
    from_date: fromDate,
    to_date: toDate
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    matchingReportsGet(params).then(response => {
      setCount(response.data.total_count);
      setShowMessage(true);
      setLoading(false);
    })
    .catch(error => {
      if(error.response.status === 404) { 
        setCount(0); 
        setShowMessage(true); 
        setLoading(false);
      } else {
        handleDefaultStatusCodes(error.response.status); 
      }
    })
  }

  return (
    <section className={`${classes.Matching_Reports_Title} section-spaces`}>
      <Container>
        <Row>
          <Col>
            <h3 className={`${classes.Matching_Reports_Title}`}>Administrative Match Reports</h3>
            { showMessage && <AlertMessage alertMessage={MATCHING_REPORTS_ALERT} styleClass='Alert_Message_MatchingReports' showCloseIcon={false} /> }
            <p>Select the date range to find the total matches occurred within that range</p>
            <form onSubmit={handleSubmit}>          
              <div className={`${classes.Matching_Reports_Body}`}> 
                <Row className={classes.Matching_Reports_Body_Row}>
                  <Col>
                    <h5>Source Information</h5>
                  </Col>
                  <Col>
                    <Select 
                      name="source-info"
                      isSearchable={false}
                      placeholder="Source Information"
                      defaultValue={{value: "opportunities", label: "Contract Opportunities"}}
                      isClear={false}
                      list={[
                        { value: "opportunities", label: "Contract Opportunities"},
                        { value: "purchases", label: "B2B Opportunities"},
                        { value: "contract_opportunities", label: "Local Opportunities" }, 
                      ]}
                      handleMultiChange={chooseEntityHandler}
                      styles="react-select-input-container"
                      prefixStyles="react-select-input"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                      <h5>Date</h5>
                  </Col>
                  <Col>
                    <div className={`${classes.DateRangeWrap}`} >
                      <DateRange 
                        handleTimeCallback={handleTimeCallback}
                        name="date"
                        id="posted_date"
                        inputStyle={classes.SearchDateRange}
                        cancelCallback = {() => {
                          setFromDate(INITIAL_DATE);
                          setToDate(INITIAL_DATE);
                          setShowMessage(false); 
                        }}
                        isPicked = {()=>{}}
                      />
                    </div>
                  </Col>
                </Row>    
              </div>
              <div className={`${classes.Matching_Reports_Submit}`}>
                <button type='submit' className='filledBtn btnSizes px-5 py-3'>
                  Submit
                </button>
              </div>
            </form>
          </Col>
        </Row>
        {loading && <Loading />}
      </Container>    
    </section>
  )
}

export default MatchingReports;
 